import type { ReactNode } from 'react';
import { flexRender, type Row } from '@tanstack/react-table';
import { useTableContext } from './TableContext';
import TableRow from './TableRow';
import { joinClasses, tableStyles } from './styles';

type RowRender<TData> = (row: Row<TData>) => ReactNode;

interface Props<TData> {
  className?: string;
  children?: ReactNode | RowRender<TData>;
}

export default function TableBody<TData>({ className, children }: Props<TData>) {
  const { table } = useTableContext<TData>();
  const { body, cell: cellClass } = tableStyles;
  const { rows } = table.getRowModel();

  if (typeof children === 'function') {
    return (
      <tbody className={joinClasses(body, className)}>
        {rows.map((rowItem) => children(rowItem))}
      </tbody>
    );
  }

  if (children) {
    return <tbody className={joinClasses(body, className)}>{children}</tbody>;
  }

  return (
    <tbody className={joinClasses(body, className)}>
      {rows.map((rowItem) => (
        <TableRow key={rowItem.id}>
          {rowItem.getVisibleCells().map((cellItem) => (
            <td key={cellItem.id} className={cellClass}>
              {flexRender(
                cellItem.column.columnDef.cell,
                cellItem.getContext()
              )}
            </td>
          ))}
        </TableRow>
      ))}
    </tbody>
  );
}
